import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { StorageService } from '../../services/common/storage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService, formatUSPhoneNumber } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { CMSContentComponent } from '../cms-content/cms-content.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';
import { CookieService } from '../../services/cookieService/cookie.service';


@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss',
})
export class SignUpComponent implements OnInit {
  //userTypes:string[]=["Customers","Firm/Agents"]
  //userType:string="";
  userTypeIdForImage: any;
  signUpForm: FormGroup;
  roles: Array<{ text: string; value: number; disabled?: boolean }> = [];
  isChecked: boolean = false;
  showError: boolean = false;
  selectedRole: number = 2;
  isPartnerFlow: boolean = false;

  // Partner referral link properties
  showPartnerBanner: boolean = false;
  partnerDisplayName: string = '';
  partnerReferenceId: string = '';
  bothPermissionsDisabled: boolean = false;

  // Zip code autocomplete
  filteredZipCodes: string[] = [];
  constructor(
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private cdRef: ChangeDetectorRef,
    private ngZone: NgZone,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private translate: TranslateService,
    private cookieService: CookieService,
  ) { }
  ngOnInit(): void {
    this.languageService.language$.subscribe(language => {
      this.translate.use(language).subscribe(() => {
        // Now the language has loaded — safe to get translations
        this.translate.get(['CUSTOMER', 'FIRM_AGENT']).subscribe(translations => {
          this.roles = [
            { text: translations.CUSTOMER, value: 2 },
            { text: translations.FIRM_AGENT, value: 3 }
          ];

          // Initialize your form here, or if already initialized, you can patch values or mark for change detection
          this.signUpForm = this.formBuilder.group({
            userTypeId: [2],
            email: ['', [Validators.required, Validators.pattern(this.commonService.SignupemailRegex)]],
            firstName: [''],
            lastName: [''],
            mobileNumber: [''],
            zipCode: [''],
            county: [{ value: '', disabled: true }],
            state: [{ value: '', disabled: true }],
          });
          this.updateValidatorsForUserType(2);
          this.route.paramMap.subscribe(params => {
            const type = params.get('type');
            if (type === 'customer') {
              this.signUpForm.patchValue({ userTypeId: 2 });
              this.updateValidatorsForUserType(2);
            } else if (type === 'firm-agent') {
              this.signUpForm.patchValue({ userTypeId: 3 });
              this.updateValidatorsForUserType(3);
            }
          });
        });
      });
    });
    //   this.translate.use(language).subscribe(() => {
    //     // Now the language has loaded — safe to get translations
    //     this.translate
    //       .get(['CUSTOMER', 'FIRM_AGENT'])
    //       .subscribe((translations) => {
    //         // Initialize your form here, or if already initialized, you can patch values or mark for change detection
    //         this.signUpForm = this.formBuilder.group({
    //           userTypeId: [3],
    //           email: [
    //             '',
    //             [
    //               Validators.required,
    //               Validators.pattern(this.commonService.SignupemailRegex),
    //             ],
    //           ],
    //         });
    //         this.route.paramMap.subscribe((params) => {
    //           const type = params.get('type');
    //           // if (type === 'customer') {
    //           //   this.signUpForm.patchValue({ userTypeId: 2 });
    //           // } else
    //           if (type === 'firm-agent') {
    //             this.signUpForm.patchValue({ userTypeId: 3 });
    //           }
    //         });
    //       });
    //   });
    // });
    // const lang = this.cookieService.get('language');
    // this.translate.use(lang || 'eng');
    this.storageService.clearAll();

    this.route.queryParams.subscribe((params) => {
      // Landing-page handoff: the account was already created and the
      // OTP already sent by common/signUp/landing-page-signup on the
      // landing page. Skip the manual email form entirely and go
      // straight to OTP verification - without this check, the form
      // renders, the user re-enters their email, and a SECOND OTP gets
      // sent via the normal userSignUp call below.
      if (params['otpSent'] === '1' && params.hasOwnProperty('email')) {
        const encEmail = decodeURIComponent(params['email'] || '');
        const encUserType = params.hasOwnProperty('usertype')
          ? decodeURIComponent(params['usertype'] || '')
          : '';
        if (encEmail) {
          const decryptedEmail = this.commonService.Decrypt(encEmail);
          const decryptedUserType = encUserType ? this.commonService.Decrypt(encUserType) : '';
          if (decryptedEmail) {
            this.storageService.setValue('email', decryptedEmail);
            this.storageService.setValue('userTypeId', decryptedUserType);
            this.router.navigate(['/verify-otp']);
            return;
          }
        }
        // Decryption failed or email missing/malformed - fall through
        // to the manual form below rather than leaving the user stuck.
      }

      if (params.hasOwnProperty('usertype')) {
        let userType = decodeURIComponent(params['usertype'] || '');
        if (userType) {
          let userTypeId = this.commonService.Decrypt(userType);
          // this.storageService.setValue('email', email);
          // this.storageService.setValue('userTypeId', userType);
          this.ShowDetailsAsPerType(userTypeId);
        }
      }

      // Partner flow: unencrypted userType query param (capital T)
      if (params['userType'] === '5') {
        this.isPartnerFlow = true;
        this.signUpForm?.patchValue({ userTypeId: 5 });
      }

      // Partner referral link: try direct code first, then decrypt for backward compatibility
      const refParam = params['ref'];
      if (refParam) {
        const decodedRef = decodeURIComponent(refParam);
        // New format: code is plain text (e.g. JohnDoe482917)
        // Old format: code is encrypted (e.g. base64-like string that decrypts to P000032)
        this.validateReferralCodeWithFallback(decodedRef);
      }
    });
  }

  ShowDetailsAsPerType(userTypeId: any) {
    if (userTypeId == '2') {
      this.signUpForm.controls['userTypeId'].setValue(2);
      this.updateValidatorsForUserType(2);
    } else if (userTypeId == '3') {
      this.signUpForm.controls['userTypeId'].setValue(3);
      this.updateValidatorsForUserType(3);
    }
  }
  onContinue() {
    if (this.isChecked) {
      this.showError = false;
    } else {
      this.showError = true;
      return;
    }
    Object.keys(this.signUpForm.controls).forEach((key) => {
      const control = this.signUpForm.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });

    // Ensure validators match the currently selected user type
    const currentUserType = this.signUpForm.controls['userTypeId'].value;
    this.updateValidatorsForUserType(currentUserType);

    this.signUpForm.markAllAsTouched();
    if (this.signUpForm.valid) {
      const userTypeId = this.signUpForm.controls['userTypeId'].value;
      const FormData: any = {
        userTypeId: userTypeId,
        email: this.signUpForm.controls['email'].value.trim(),
        UserId: 0,
      };

      // Include customer-specific fields when userTypeId === 2
      if (userTypeId === 2) {
        FormData.firstName = this.signUpForm.controls['firstName'].value;
        FormData.lastName = this.signUpForm.controls['lastName'].value;
        FormData.mobileNumber = this.signUpForm.controls['mobileNumber'].value.replace(/\D/g, '');
        FormData.zipCode = this.signUpForm.controls['zipCode'].value;
        FormData.county = this.signUpForm.getRawValue().county;
        FormData.state = this.signUpForm.getRawValue().state;
      }

      this.storageService.setValue('userTypeId', String(userTypeId));
      this.spinner.show();
      const apiUrl = this.apiUrl.apiUrl.signUp.userSignUp;
      this.apiService
        .doPost(apiUrl, FormData)
        .pipe()
        .subscribe({
          next: (response) => {
            this.spinner.hide();
            if (response && response.Success) {
              this.toaster.success(this.translate.instant(response.Message));
              this.storageService.setValue('email', response.Data.Email);
              const UserId = String(userTypeId);
              this.storageService.setValue('userTypeId', UserId);

              // Store customer fields for auto-population
              if (userTypeId === 2) {
                this.storageService.setValue('firstName', FormData.firstName);
                this.storageService.setValue('lastName', FormData.lastName);
                this.storageService.setValue('mobileNumber', FormData.mobileNumber);
                this.storageService.setValue('zipCode', FormData.zipCode);
                this.storageService.setValue('county', FormData.county);
                this.storageService.setValue('state', FormData.state);
              }

              this.router.navigate(['/verify-otp']);
            } else {
              this.toaster.error(this.translate.instant(response.Message));
            }
          },
          error: (er) => {
            this.spinner.hide();
            console.error(er);
            this.toaster.error(er.Message);
          },
        });
    }
  }
  onCheckboxChange(event: any) {
    if (event.checked) {
      this.showError = false;
      this.isChecked = true;
    } else {
      this.showError = true;
      this.isChecked = false;
    }
  }

  openDialog(content?: any): void {
    const dialogRef = this.dialog.open(CMSContentComponent, {
      width: '500px',
      data: content ? { content: content } : null,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  getBackgroundClass(): string {
    const userTypeId = this.signUpForm?.get('userTypeId')?.value;
    if (userTypeId == 2) {
      return 'signupimage-height';
    } else if (userTypeId == 3) {
      return 'firmagent-signup';
    }
    return '';
  }

  onUserTypeChange(value: number) {
    this.updateValidatorsForUserType(value);
    if (value === 2) {
      // this.router.navigate(['/signup/customer'], { replaceUrl: true });
      this.signUpForm.patchValue({ userTypeId: 3 });
      return;
    } else if (value === 3) {
      this.router.navigate(['/signup/firm-agent'], { replaceUrl: true });
    }
  }

  updateValidatorsForUserType(userTypeId: number): void {
    const firstNameCtrl = this.signUpForm.get('firstName');
    const lastNameCtrl = this.signUpForm.get('lastName');
    const mobileNumberCtrl = this.signUpForm.get('mobileNumber');
    const zipCodeCtrl = this.signUpForm.get('zipCode');
    const countyCtrl = this.signUpForm.get('county');
    const stateCtrl = this.signUpForm.get('state');

    if (userTypeId === 2) {
      firstNameCtrl?.setValidators([Validators.required]);
      lastNameCtrl?.setValidators([Validators.required]);
      mobileNumberCtrl?.setValidators([Validators.required, Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)]);
      zipCodeCtrl?.setValidators([Validators.required, Validators.pattern(/^\d{5}$/)]);
      countyCtrl?.setValidators([Validators.required]);
      stateCtrl?.setValidators([Validators.required]);
    } else {
      firstNameCtrl?.clearValidators();
      lastNameCtrl?.clearValidators();
      mobileNumberCtrl?.clearValidators();
      zipCodeCtrl?.clearValidators();
      countyCtrl?.clearValidators();
      stateCtrl?.clearValidators();
    }

    firstNameCtrl?.updateValueAndValidity();
    lastNameCtrl?.updateValueAndValidity();
    mobileNumberCtrl?.updateValueAndValidity();
    zipCodeCtrl?.updateValueAndValidity();
    countyCtrl?.updateValueAndValidity();
    stateCtrl?.updateValueAndValidity();
  }

  onZipCodeChange(): void {
    const input = this.signUpForm.get('zipCode')?.value;
    if (input && input.length >= 3) {
      this.loadZipCodes(input);
    } else {
      this.filteredZipCodes = [];
      this.signUpForm.patchValue({ county: '', state: '' });
    }
  }

  loadZipCodes(filter: string): void {
    const url = `${this.apiUrl.apiUrl.FirmRegistration.GetZipCodes}?ZipCode=${filter}`;
    this.apiService.doGet(url).subscribe({
      next: (response: any) => {
        if (response?.Success) {
          this.filteredZipCodes = response.Data.map(
            (zipObj: { ZIPCode: string }) => zipObj.ZIPCode
          );
        }
      },
      error: () => {
        this.filteredZipCodes = [];
      },
    });
  }

  onZipCodeSelected(zip: string): void {
    this.signUpForm.get('zipCode')?.setValue(zip);
    this.filteredZipCodes = [];
    this.fetchStateCountyByZip(zip);
  }

  onMobileNumberInput(): void {
    const ctrl = this.signUpForm.get('mobileNumber');
    if (ctrl) {
      const formatted = formatUSPhoneNumber(ctrl.value);
      ctrl.setValue(formatted, { emitEvent: false });
    }
  }

  private fetchStateCountyByZip(zipCode: string): void {
    const url = this.apiUrl.apiUrl.FirmRegistration.GetStateCountyCity;
    this.apiService.doPost(url, { ZIPCode: zipCode }).subscribe({
      next: (response: any) => {
        if (response?.Data) {
          this.signUpForm.patchValue({
            county: response.Data.County || '',
            state: response.Data.State || '',
          });
        } else {
          this.signUpForm.patchValue({ county: '', state: '' });
        }
      },
      error: () => {
        this.signUpForm.patchValue({ county: '', state: '' });
      },
    });
  }

  validateReferralCodeWithFallback(refParam: string): void {
    // Try validating the code directly (new plain-text format)
    const apiUrl = this.apiUrl.apiUrl.partner.validateReferralCode + encodeURIComponent(refParam);
    this.apiService.doGet(apiUrl).subscribe({
      next: (response) => {
        if (response && response.Success && response.Data && response.Data.IsValid) {
          this.showPartnerBanner = true;
          this.partnerDisplayName = response.Data.DisplayName || '';
          this.partnerReferenceId = response.Data.PartnerReferralCode || response.Data.PartnerReferenceId || refParam;
          this.applyReferralPermissions(response.Data);
          try {
            sessionStorage.setItem('PartnerReferenceId', this.partnerReferenceId);
          } catch (e) {}
        } else {
          // Direct validation failed — try decrypting (old encrypted format)
          try {
            const decryptedCode = this.commonService.Decrypt(refParam);
            if (decryptedCode) {
              this.validateReferralCode(decryptedCode);
            } else {
              this.showPartnerBanner = false;
            }
          } catch (e) {
            this.showPartnerBanner = false;
          }
        }
      },
      error: () => {
        this.showPartnerBanner = false;
      },
    });
  }

  validateReferralCode(refCode: string): void {
    const apiUrl = this.apiUrl.apiUrl.partner.validateReferralCode + encodeURIComponent(refCode);
    this.apiService.doGet(apiUrl).subscribe({
      next: (response) => {
        if (response && response.Success && response.Data && response.Data.IsValid) {
          this.showPartnerBanner = true;
          this.partnerDisplayName = response.Data.DisplayName || '';
          this.partnerReferenceId = response.Data.PartnerReferralCode || response.Data.PartnerReferenceId || refCode;
          this.applyReferralPermissions(response.Data);
          try {
            sessionStorage.setItem('PartnerReferenceId', this.partnerReferenceId);
          } catch (e) {
            // sessionStorage unavailable (e.g. private browsing) — graceful degradation
          }
        } else {
          this.showPartnerBanner = false;
        }
      },
      error: () => {
        // Network failure — hide banner, proceed with standard signup
        this.showPartnerBanner = false;
      },
    });
  }

  /** Disable dropdown options based on partner's AllowAddCustomer / AllowAddFirm toggles */
  private applyReferralPermissions(data: any): void {
    const allowCustomer = data.AllowAddCustomer === true;
    const allowFirm = data.AllowAddFirm === true;

    // If both are off, block the entire form
    this.bothPermissionsDisabled = !allowCustomer && !allowFirm;

    // Update roles array to mark disabled items
    this.roles = this.roles.map(role => ({
      ...role,
      disabled: (role.value === 2 && !allowCustomer) || (role.value === 3 && !allowFirm),
    }));

    // If current selection is disabled, switch to the other one
    const currentType = this.signUpForm?.get('userTypeId')?.value;
    if (currentType === 2 && !allowCustomer && allowFirm) {
      this.signUpForm?.patchValue({ userTypeId: 3 });
    } else if (currentType === 3 && !allowFirm && allowCustomer) {
      this.signUpForm?.patchValue({ userTypeId: 2 });
    }
  }
}
